import React from "react";
import "./App.css";
import { HashRouter as Router } from "react-router-dom";
import { Provider } from "jotai";
import RootRouter from "./routes";
import { ToastContainer } from "react-toastify";
import { WebChatProvider } from "./context/webChatContext";

function App() {
  return (
    <Provider>
      <Router>
        <WebChatProvider>
          <RootRouter />
          <ToastContainer />
        </WebChatProvider>
      </Router>
    </Provider>
  );
}

export default App;
